<template>
	<router-link
		class="unit-link"
		:to="{ name: 'unit', params: { unitId: unit.id } }">
		<div>
			<v-card class="mx-auto unitCard" max-width="250" :loading="loading">
				<template v-slot:loader="{ isActive }">
					<v-progress-linear
						:active="isActive"
						color="deep-purple"
						height="4"
						indeterminate
					></v-progress-linear>
				</template>
				<div style="text-align: center;">
					<div class="card-title bold">{{unit.name}}</div>
					<v-card-subtitle style="padding-top: 0px;">{{unit.address}}</v-card-subtitle>
					<!-- <div class="trashIcon" @click="deleteUnit"><font-awesome-icon class="icon" icon="trash" /></div> -->
				</div>
			</v-card>
		</div>




		<!-- <div class="unit-card card">
			<div class="centered">
				<h4 style="margin: auto;" class="card-title card-name score-control__header"><div>{{ unit.name }}</div></h4>
				<div class="card-text score-control__header"><div>{{ unit.address }}</div></div>
				<br />
				<div class="trashIcon" @click="deleteUnit"><font-awesome-icon class="icon" icon="trash" /></div>
			</div>
		</div> -->


	</router-link>
</template>

<script>
export default {
	data() {
		return {
		id: this.unit.id,
		loading: false
		}
	},
	methods: {
		deleteUnit(event) {
		event.preventDefault()
		if (confirm('are you sure?')) {
			this.$store
			.dispatch('unit/removeUnit', this.id)
			.then(() => {
				this.$store.dispatch('unit/fetchUnits')
			})
			.catch(e => console.log(e))
		}
		},
		reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
    }
	},
	props: {
		unit: Object
	}
}
</script>

<style  lang="scss" scoped>

.unit-link {
	text-decoration: none;
}
.unitCard {
	height: 160px;
	margin: 20px 10px !important;
	background: rgba(128, 128, 128, 0.1) !important;
}

.card-title {
	width: 240px;
	padding-top: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin-top:35px;
	margin: 10px;
	text-align: center;
	font-size: 1.5rem;
	font-weight: 800;
}
.bold {
	font-weight: 700 !important;

}

@media screen and (min-width: 500px){
	.unitCard:hover {
	background: rgba(128, 128, 128, 0.2) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}
}

@media screen and (max-width: 780px){
.unitCard {
		height: auto !important;
	}
}
@media screen and (max-width: 500px){
	.unitCard {
    margin: 20px auto !important;
	}
	.card-title {
			width: 225px !important;
			margin-top: 10px;
			line-height: 30px;
	}
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
	text-align: left;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 270px;
}
}

</style>
